import React from "react";
import InvestComponent from "../../components/money/invest";

const MoneyInvest = () => {
  return <div className="text-black flex-1"><InvestComponent/></div>;
};

export default MoneyInvest;
